<template>
  <div class="aside-box">
    <div class="title-box">
      <p class="title">导航</p>
    </div>
    <div class="box-body" style="padding-bottom: 20px">
      <div class="info-content tab-info-content">
        <ul class="tab-list" id="nav-list">
          <li
            class="tab-li"
            :class="{ 'current-tab': currentTab == item3.menuType }"
            v-for="(item3, index3) in tabList"
            :key="index3"
            :style="item3.menuType == 5 ? 'height: 113px' : ''"
          >
            <div class="tab-header">
              <p class="tab-order">导航{{ index3 + 1 }}</p>
              <p class="content-origin">
                内容来源：{{ getTabName(item3.menuType) }}
              </p>
            </div>
            <div class="tab-body">
              <div class="tab-name">
                <span>*</span>
                <p>名称</p>
                <el-input
                  v-model="item3.alias"
                  placeholder="建议输入4个字以内"
                  maxlength="4"
                  show-word-limit
                  class="tab-name-input"
                  @focus="currentTab = item3.menuType"
                  @blur="currentTab = 0"
                  @input="changeTabName()"
                ></el-input>
              </div>
              <div v-if="item3.menuType == 5" class="tab-introduce">
                <p>详情</p>
                <div class="tab-edit-btn" @click="openOrCloseDialog()">
                  <img
                    src="../../../assets/images/pc-decoration/create-swiper-icon.png"
                    alt=""
                    class="edit-icon"
                  />
                  编辑
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <p class="tab-tips">系统自动调取相应内容，若无内容，则不显示相应导航</p>
    </div>
  </div>
</template>

<script>
import Sortable from "sortablejs";
export default {
  name: "ShopCenterAdminWebMAsideTab",
  components: {},
  data() {
    return {
      tabList: [],
      currentTab: 0,
    };
  },

  mounted() {
    // 获取tab导航数据
    this.tabList = JSON.parse(
      JSON.stringify(this.$store.state.mDecoration.tabList)
    );
    // 开启拖拽功能
    this.$nextTick(() => {
      // 开启拖拽排序
      var el = document.getElementById("nav-list");
      new Sortable(el, {
        animation: 150,
        filter: ".no-change",
        onUpdate: (evt) => {
          // 改变数组排序
          const temp = this.tabList[evt.oldIndex];
          this.tabList.splice(evt.oldIndex, 1);
          this.tabList.splice(evt.newIndex, 0, temp);
          // 重新按顺序渲染dom 确保视图和数据一致
          const arr = this.tabList.slice(0);
          this.tabList = [];
          this.$nextTick(() => {
            this.tabList = arr;
            this.updateTabList();
          });
        },
      });
    });
  },

  methods: {
    // 获取tab内容来源
    getTabName(menuType) {
      const arr = ["文章", "视频", "资料", "专辑", "简介"];
      return arr[menuType - 1];
    },
    // 修改导航名称
    changeTabName() {
      this.updateTabList();
    },
    // 打开简介富文本弹窗
    openOrCloseDialog() {
      // 更新数据到vuex中
      this.$store.commit("mDecoration/setDialogType", "tabEditor");
    },
    // 更新数据至vuex中
    updateTabList() {
      this.$store.commit("mDecoration/setTabList", this.tabList);
    },
  },
};
</script>

<style lang="scss" scoped>
.aside-box {
  .title-box {
    margin: 0px 0 20px;
    .title {
      color: #606266;
      font-size: 15px;
      font-style: normal;
      line-height: 15px;
      margin-right: 20px;
    }
  }
  .box-body {
    .info-content {
      padding-left: 12px;

      .info-content-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 24px;

        & > span {
          margin-right: 4px;
          font-size: 15px;
          font-weight: 600;
          color: #fe4509;
        }

        & > p {
          width: 80px;
          font-size: 12px;
          color: #606266;
        }
        & > div {
          width: 220px;
        }

        ::v-deep .el-radio-group.group-type2 .el-radio {
          margin-bottom: 20px;
        }
      }

      .info-content-item2 {
        transform: translateX(-12px);
      }

      .zdy-content {
        .content-list {
          .content-li {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 280px;
            height: 32px;
            padding: 0 15px;
            margin-bottom: 15px;
            background: #f5f5f5;
            border-radius: 5px;

            p {
              width: 250px;
              font-size: 12px;
              color: #606266;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .del-content-icon {
              width: 11px;
              height: 12px;
              background: url(../../../assets/images/pc-decoration/del-floor-icon.png)
                no-repeat;
              background-size: 100% 100%;
              cursor: pointer;

              &:hover {
                background: url(../../../assets/images/pc-decoration/del-floor-icon2.png)
                  no-repeat;
                background-size: 100% 100%;
              }
            }
          }
        }
      }

      .nav-list {
        .nav-li {
          width: 278px;
          height: 180px;
          padding: 15px 15px;
          margin-bottom: 20px;
          background: #ffffff;
          border: 1px dashed transparent;

          .nav-header {
            display: flex;
            align-items: center;
            justify-content: space-between;

            p {
              font-weight: 500;
              font-size: 13px;
              color: #606266;
            }

            .del-nav-icon {
              display: none;
              width: 11px;
              height: 12px;
              background: url(../../../assets/images/pc-decoration/del-floor-icon.png)
                no-repeat;
              background-size: 100% 100%;
              cursor: pointer;

              &:hover {
                background: url(../../../assets/images/pc-decoration/del-floor-icon2.png)
                  no-repeat;
                background-size: 100% 100%;
              }
            }
          }
          &:hover {
            border: 1px dashed #c0d0ff;
            box-shadow: 0px 0px 10px rgba(191, 191, 191, 0.25);
            border-radius: 5px;

            .del-nav-icon {
              display: block;
            }
          }
          .nav-body {
            margin-top: 15px;

            & > div {
              display: flex;
              align-items: center;
              justify-content: flex-start;

              p {
                width: 70px;
                font-size: 12px;
                color: #606266;
                white-space: nowrap;
              }
            }
            .nav-name {
              margin-bottom: 15px;
              span {
                margin-left: -9px;
                margin-right: 4px;
                font-size: 12px;
                font-weight: 600;
                color: #fe4509;
              }
              .nav-name-input {
                width: 210px;
              }
            }

            .nav-img {
              margin-bottom: 15px;

              .nav-img-box {
                position: relative;
                width: 30px;
                height: 30px;
                margin-right: 10px;
                border-radius: 5px;
                background-size: 100% 100%;
                transition: all 0.2s linear;

                .del-img-box {
                  display: none;
                  align-items: center;
                  justify-content: center;
                  position: absolute;
                  top: 0px;
                  right: 0px;
                  left: 0px;
                  bottom: 0px;
                  width: 100%;
                  height: 100%;
                  background: rgba(0, 0, 0, 0.4);
                  border-radius: 5px;

                  .del-img-icon {
                    width: 11px;
                    height: 12px;
                    background: url(../../../assets/images/pc-decoration/del-floor-icon3.png)
                      no-repeat;
                    background-size: 100% 100%;
                    cursor: pointer;

                    &:hover {
                      background: url(../../../assets/images/pc-decoration/del-floor-icon2.png)
                        no-repeat;
                      background-size: 100% 100%;
                    }
                  }
                }

                &:hover {
                  .del-img-box {
                    display: flex;
                  }
                }
              }

              .add-img-box {
                width: 30px;
                height: 30px;
                margin-right: 10px;
                background: #ffffff;
                border: 1px dashed #a3baff;
                border-radius: 5px;
                font-size: 18px;
                text-align: center;
                line-height: 28px;
                font-weight: 500;
                color: #5a83ff;
                cursor: pointer;
              }
              .nav-img-tips {
                width: 175px;
                font-size: 12px;
                color: #c4c8d0;
              }
            }

            .nav-url {
              .nav-url-input {
                width: 210px;
              }
            }
          }
        }
      }

      .swiper-list {
        .swiper-li {
          .swiper-body {
            .swiper-img {
              .swiper-img-show {
                width: 210px;
                height: 40px;
                border-radius: 5px;
              }
              .create-swiper-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 210px;
                height: 30px;
                background: #ffffff;
                border: 1px solid #a2baff;
                border-radius: 5px;
                cursor: pointer;

                .create-swiper-icon {
                  width: 9px;
                  height: 12px;
                  margin-right: 5px;
                }

                p {
                  font-size: 12px;
                  color: #5a83ff;
                }
              }
            }
            .swiper-tips {
              margin-bottom: 15px;
              color: #c4c8d0;
            }
          }
        }
      }
      .show-shop-info {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        .shop-info-title {
          width: 70px;
          margin-right: 12px;
          font-size: 12px;
          color: #606266;

          span {
            font-weight: 600;
            font-size: 12px;
            color: #fe4509;
          }
        }
        .shop-info-list {
          width: 230px;
          overflow: hidden;

          .shop-info-li {
            float: left;
            width: 75px;
            margin-bottom: 10px;

            ::v-deep .el-checkbox__label {
              font-size: 12px;
              color: #606266;
            }
          }
        }
      }
      .info-origin {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 20px;
        .info-title {
          width: 70px;
          margin-right: 12px;
          font-size: 12px;
          color: #606266;

          span {
            font-weight: 600;
            font-size: 12px;
            color: #fe4509;
          }
        }
        ::v-deep .el-input--suffix .el-input__inner {
          width: 220px;
        }
        ::v-deep .el-scrollbar__wrap {
          overflow-x: auto !important;
        }
      }
      .info-order {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        .info-title {
          width: 70px;
          margin-right: 12px;
          font-size: 12px;
          color: #606266;

          span {
            font-weight: 600;
            font-size: 12px;
            color: #fe4509;
          }
        }

        ::v-deep .el-radio-group {
          width: 220px;

          .el-radio {
            margin-bottom: 20px;
          }
        }
      }
      .add-content-li {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 310px;
        height: 32px;
        margin-bottom: 30px;
        background: #ffffff;
        border: 1px dashed #5a83ff;
        border-radius: 5px;
        cursor: pointer;

        span {
          font-size: 20px;
          font-weight: 500;
          transform: translate(-2px, -2px);
          color: #5a83ff;
        }

        p {
          font-size: 14px;
          color: #5a83ff;
        }
        div {
          font-size: 12px;
          color: #c4c8d0;
        }

        .edit-icon {
          width: 9px;
          height: 12px;
          margin-right: 5px;
        }
      }
    }
    .tab-info-content {
      padding-bottom: 30px;
      .tab-list {
        .tab-li {
          width: 278px;
          height: 65px;
          padding: 15px 15px;
          margin-bottom: 20px;
          background: #ffffff;
          border: 1px dashed transparent;
          cursor: pointer;
          &:hover {
            border: 1px dashed #c0d0ff;
            box-shadow: 0px 0px 10px rgba(191, 191, 191, 0.25);
            border-radius: 5px;
          }
          .tab-header {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .tab-order {
              font-weight: 500;
              font-size: 13px;
              line-height: 13px;
              color: #606266;
            }
            .content-origin {
              font-weight: 400;
              font-size: 12px;
              line-height: 12px;
              color: #c4c8d0;
            }
          }
          .tab-body {
            margin-top: 15px;

            & > div {
              display: flex;
              align-items: center;
              justify-content: flex-start;

              p {
                width: 50px;
                font-size: 12px;
                color: #606266;
                white-space: nowrap;
              }
            }
            .tab-name {
              margin-bottom: 15px;
              span {
                margin-left: -9px;
                margin-right: 4px;
                font-size: 12px;
                font-weight: 600;
                color: #fe4509;
              }
              .tab-name-input {
                width: 230px;
              }
            }
            .tab-introduce {
              margin-bottom: 15px;
              .tab-edit-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 230px;
                height: 32px;
                background: #ffffff;
                border: 1px solid #a2baff;
                border-radius: 5px;
                font-size: 12px;
                line-height: 12px;
                color: #5a83ff;
                opacity: 1;

                img {
                  width: 9px;
                  height: 11px;
                  margin-right: 4px;
                }

                &:hover {
                  opacity: 0.9;
                }
              }
            }
          }
        }
        .current-tab {
          border: 1px dashed #c0d0ff;
          box-shadow: 0px 0px 10px rgba(191, 191, 191, 0.25);
          border-radius: 5px;
        }
      }
    }
    .tab-tips {
      font-size: 12px;
      line-height: 12px;
      color: #c4c8d0;
      text-align: center;
    }
  }
}
</style>
